// Rapports: one line « Coupons : X imprimés · Y utilisés · Z DH », only once
// coupons exist (and only for someone who may read the coupon numbers).
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { couponsApi } from '@/lib/api';
import { useT } from '@/lib/i18n';
import { couponsReportText } from './couponMath';

export function CouponsReportLine({ enabled }: { enabled: boolean }) {
  const { t } = useT();
  const { data } = useQuery({
    queryKey: ['coupon-stats'],
    queryFn: () => couponsApi.stats(),
    enabled,
    staleTime: 60_000,
    retry: false, // before the worker routes are deployed: no line, no noise
  });
  const text = data ? couponsReportText(data) : null;
  if (!enabled || !text) return null;
  return (
    <p className="mb-5 text-sm text-adm-ink-2">
      <Link to="/admin/coupons" className="hover:underline">
        🎟 {t('Coupons : {p} imprimés · {u} utilisés · {r} DH', text)}
      </Link>
    </p>
  );
}
